var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 115,
    viewBox: "0 0 99 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.9747 99.408L91.8924 25.2577C91.7407 23.6115 90.2483 22.365 88.5031 22.365H73.9338C73.7315 9.99489 62.8551 0 49.5 0C36.1449 0 25.2685 9.99489 25.0662 22.365H10.4969C8.72637 22.365 7.25933 23.6115 7.10756 25.2577L0.0252944 99.408C0.0252944 99.502 0 99.5961 0 99.6902C0 108.133 8.32166 115 18.5657 115H80.4343C90.6783 115 99 108.133 99 99.6902C99 99.5961 99 99.502 98.9747 99.408ZM49.5 6.34969C59.0864 6.34969 66.9021 13.499 67.1045 22.365H31.8955C32.0979 13.499 39.9136 6.34969 49.5 6.34969ZM80.4343 108.65H18.5657C12.141 108.65 6.93051 104.699 6.82933 99.8313L13.6081 28.7382H25.0409V38.3804C25.0409 40.1442 26.5585 41.5552 28.4555 41.5552C30.3526 41.5552 31.8702 40.1442 31.8702 38.3804V28.7382H67.1045V38.3804C67.1045 40.1442 68.6221 41.5552 70.5192 41.5552C72.4162 41.5552 73.9338 40.1442 73.9338 38.3804V28.7382H85.3666L92.1707 99.8313C92.0695 104.699 86.8337 108.65 80.4343 108.65Z",
    fill: "#6CC51D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/ShoppingBag.3d5aadaf1e7acb6d5dbcb83589cd8fa4.svg";
export { ForwardRef as ReactComponent };